import { render } from "./JourneyFeed.vue?vue&type=template&id=63a823c1&lang=pug"
import script from "./JourneyFeed.vue?vue&type=script&lang=ts"
export * from "./JourneyFeed.vue?vue&type=script&lang=ts"

import "./JourneyFeed.vue?vue&type=style&index=0&id=63a823c1&lang=scss"
script.render = render

export default script